import { Box } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import React from 'react';
import { StructuredContentRenderer } from '../..';
import { ColumnsContext } from './Columns';
import { BORDER_RADIUS_MAP, COLORS_MAP, SPACING_MAP } from './constants';
import type { BorderRadiusToken, ColumnWidth, SpacingToken, WidthObject } from './types';
import type { ColorToken } from '../../types';
import { isWidthObject } from './utils';

type ColumnProps = StructuredContentDocument<{
  backgroundColor?: ColorToken;
  borderRadius?: BorderRadiusToken;
  children: StructuredContentDocument;
  columnStart?: ColumnWidth;
  equalHeight?: boolean;
  order?: { desktop?: number; mobile?: number };
  padding?: SpacingToken;
  width?: WidthObject | ColumnWidth;
}>;

export const Column = ({ props }: ColumnProps) => {
  const {
    backgroundColor,
    borderRadius,
    children,
    columnStart,
    equalHeight,
    order,
    padding,
    width,
  } = props;
  const { collapse } = React.useContext(ColumnsContext);

  return (
    <Box
      sx={{
        height: equalHeight ? '100%' : undefined,
        p: SPACING_MAP[padding || 0],
        borderRadius: BORDER_RADIUS_MAP[borderRadius || 0],
        bgcolor: COLORS_MAP[backgroundColor ?? 'white'],
        gridColumnStart: collapse ? 'unset !important' : (columnStart ?? undefined),
        order: order ? order : undefined,
        gridColumnEnd: {
          xs: collapse ? undefined : `span ${Number(isWidthObject(width) ? width.mobile : width)}`,
          sm: `span ${Number(isWidthObject(width) ? width.desktop : width)}`,
        },
      }}
    >
      <StructuredContentRenderer doc={children} />
    </Box>
  );
};
